import {RouteConfig} from 'vue-router';
import Timeline from '@/components/Challenges/tabs/timeline/Timeline.vue';

export const challengeTimelineRouter: RouteConfig[] = [
  {
    path: '',
    name: 'challenge-timeline',
    component: Timeline,
  },
  // {
  //   path: 'interaction/:id',
  //   name: 'timeline-interaction',
  //   component: TimelineInteraction,
  //   beforeEnter: (to, from, next) => {
  //     if (authenticated()) {
  //       next()
  //     } else {
  //       next(from.path)
  //     }
  //   }
  // }
];
